const initialState = {
  alert: [],
  newalert: [],
  lastScore: null,
};

const alertsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case "SET_AlERTS_DATA":
      let payload = action.payload;

      return { ...state, alert: [action.payload] };
    case "SET_NEW_AlERTS_DATA":
      return { ...state, newalert: action.payload };
    case "SET_ALERT_STATE":
      return initialState;
    case "SET_LAST_SCORE":
      return { ...state, lastScore: action.payload };
    default:
      return state;
  }
};

export default alertsReducer;
